import React from "react";
import { StructureAnswersForSelectables } from "Global/Components/Generators/FormElementCreatorByType/Functions/StructureAnswersForSelectables";
import EditableStandaloneRadio from "Global/Components/EditableComponents/EditableStandaloneRadio/EditableStandaloneRadio";
import EditablePersianSupportNumericTextField from "Global/Components/EditableComponents/EditablePersianSupportNumericTextField";
import EditableCustomizableAutoComplete from "Global/Components/EditableComponents/EditableCustomizableAutoComplete/EditableCustomizableAutoComplete";
import EditableMuiDatePicker from "Global/Components/EditableComponents/EditableMuiDatePicker/EditableMuiDatePicker";
import { GetCurrentDateInJalai } from "utils/GetCurrentDateInJalai";
import EditableSingularTimePicker from "Global/Components/EditableComponents/EditableSingularTimePicker/EditableSingularTimePicker";
import EditableCustomizableSelect from "Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect";
import EditableCustomCheckBox from "Global/Components/EditableComponents/EditableCustomCheckBox.js/EditableCustomCheckBox";
import EditablePersianSupportTextField from "Global/Components/EditableComponents/EditablePersianSupportTextField";

const GridElementGenerator = ({
  element,
  onChange,
  RadioButton,
  setRadioButton,
  EditValue = null,
  field,
}) => {
  return (
    <React.Fragment>
      {element?.ElsRecord?.Type === "RadioButton" ? (
        <EditableStandaloneRadio
          RadioValue={RadioButton}
          compareField={element?.ElsRecord?.Id}
          setUi={setRadioButton}
          placeholder={element?.HeaderColumn}
          onChange={onChange}
          UiItem={field}
        />
      ) : element?.ElsRecord?.Type === "TextBox" ? (
        <EditablePersianSupportTextField
          label={element?.HeaderColumn}
          onChange={onChange}
          isEnglish={true}
          Initialvalue={EditValue ?? ""}
        />
      ) : element?.ElsRecord?.Type === "ComboBox" ? (
        <EditableCustomizableAutoComplete
          onChange={onChange}
          SelectableDataArray={StructureAnswersForSelectables(
            element?.ElsRecord?.ListDefaultAnswer,
            "ComboBox"
          )}
          label={element?.HeaderColumn}
          completeOutPut={true}
          defaultValue={EditValue ? EditValue[0] : ""}
          isSmall={true}
        />
      ) : element?.ElsRecord?.Type === "Date" ? (
        <EditableMuiDatePicker
          Placeholder={element?.HeaderColumn}
          onChange={onChange}
          disableInit={true}
          initialValue={
            EditValue
              ? EditValue.length > 0
                ? EditValue
                : GetCurrentDateInJalai()
              : GetCurrentDateInJalai()
          }
        />
      ) : element?.ElsRecord?.Type === "Time" ? (
        <EditableSingularTimePicker
          isEnglish={true}
          label={element?.HeaderColumn}
          onChange={onChange}
          initalValue={EditValue}
        />
      ) : element?.ElsRecord?.Type === "RadCheckedDropDownList" ? (
        <EditableCustomizableSelect
          onChange={onChange}
          SelectableDataArray={StructureAnswersForSelectables(
            element?.ElsRecord?.ListDefaultAnswer,
            "RadCheckedDropDownList"
          )}
          label={element?.HeaderColumn}
          isEnglish={false}
          swipleToLeftTitle={true}
          CompleteOutPut={true}
          initialData={field?.value || []}
          isSmall={true}
        />
      ) : element?.ElsRecord?.Type === "CheckBox" ? (
        <EditableCustomCheckBox
          label={element?.HeaderColumn}
          onChange={onChange}
          defaultChecked={
            EditValue && EditValue.toString().length > 0 ? true : false
          }
        />
      ) : element?.ElsRecord?.Type === "Numeric" ? (
        <EditablePersianSupportNumericTextField
          label={element?.HeaderColumn}
          onChange={onChange}
          isEnglish={true}
          value={EditValue ?? ""}
        />
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default GridElementGenerator;
